module.exports = __webpack_public_path__ + "img/gbwhatsapp-not-working.57f2d5cd.webp";